import { useTranslation } from 'next-i18next'
import { makeStyles, Container, Link as MuiLink } from '@material-ui/core'
import T from '../../home-new/tokens'
import Reveal from '../../home-new/Reveal'

// Three white info cards ("สำนักงานใหญ่" / "เบอร์ติดต่อและเวลาทำการ" /
// "อีเมลติดต่อและช่องทางออนไลน์"), each topped by a circular blue icon badge
// (icon-office.png / icon-phone.png / icon-email.png — cropped from the
// mockup). Content matches the design 1:1; layout follows the CoreServices
// (/service?new) card grid.
// Labels are i18n keys (under new.cards.email.*) resolved at render time; the
// email addresses themselves are literal and stay untranslated.
const emails = [
  { labelKey: 'label-cs', address: 'cs@shippop.com' },
  { labelKey: 'label-sales', address: 'sale@shippop.com' },
  { labelKey: 'label-acc', address: 'bill@shippop.com' },
  { labelKey: 'label-hr', address: 'job@shippop.com' },
]

const socials = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/shippop.official',
    bg: '#1877F2',
    path: (
      <path d="M13.5 21v-7.7h2.6l.4-3h-3v-1.9c0-.87.24-1.46 1.5-1.46h1.6V4.3c-.28-.04-1.24-.12-2.35-.12-2.33 0-3.93 1.42-3.93 4.03v2.1H7.7v3h2.6V21h3.2z" />
    ),
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@shippop',
    bg: '#000000',
    path: (
      <path d="M16.6 5.1c.8.9 1.9 1.5 3.2 1.6v2.6a5.8 5.8 0 0 1-3.2-.97v6.1a5.15 5.15 0 1 1-4.44-5.1v2.7a2.45 2.45 0 1 0 1.74 2.35V3h2.7c0 .1 0 .1 0 0v.02c.01.75.09 1.5 0 0z" />
    ),
  },
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/channel/UCqthHHdPcpFlI8gTA6TAOdw',
    bg: '#FF0000',
    path: (
      <path d="M21.6 8.1a2.8 2.8 0 0 0-1.97-2C18 5.6 12 5.6 12 5.6s-6 0-7.63.5A2.8 2.8 0 0 0 2.4 8.1 29.4 29.4 0 0 0 1.9 13a29.4 29.4 0 0 0 .5 4.9 2.8 2.8 0 0 0 1.97 2C6 20.4 12 20.4 12 20.4s6 0 7.63-.5a2.8 2.8 0 0 0 1.97-2 29.4 29.4 0 0 0 .5-4.9 29.4 29.4 0 0 0-.5-4.9zM10 16.2V9.8l5.3 3.2-5.3 3.2z" />
    ),
  },
  {
    name: 'LINE',
    href: 'https://line.me/ti/p/%40shippop',
    bg: '#06C755',
    path: (
      <path d="M12 3.6c-5.25 0-9.5 3.53-9.5 7.88 0 3.9 3.37 7.17 7.92 7.79.31.07.72.2.83.47.1.24.06.62.03.86l-.13.8c-.04.24-.19.94.82.51 1.01-.42 5.46-3.22 7.45-5.51 1.37-1.5 2.08-3.03 2.08-4.92 0-4.35-4.25-7.88-9.5-7.88zm-2.98 10.1H6.9a.33.33 0 0 1-.33-.33v-4.1c0-.18.15-.33.33-.33s.33.15.33.33v3.77h1.79c.18 0 .33.15.33.33s-.15.33-.33.33zm1.66-.33c0 .18-.15.33-.33.33s-.33-.15-.33-.33v-4.1c0-.18.15-.33.33-.33s.33.15.33.33v4.1zm4.68 0a.33.33 0 0 1-.33.33.34.34 0 0 1-.27-.13l-2.08-2.83v2.63c0 .18-.15.33-.33.33s-.33-.15-.33-.33v-4.1c0-.14.09-.27.23-.31a.33.33 0 0 1 .37.12l2.08 2.83V9.27c0-.18.15-.33.33-.33s.33.15.33.33v4.1zm2.85-2.38c.18 0 .33.15.33.33s-.15.33-.33.33h-1.46v1.11h1.46c.18 0 .33.15.33.33s-.15.33-.33.33h-1.79a.33.33 0 0 1-.33-.33v-4.1c0-.18.15-.33.33-.33h1.79c.18 0 .33.15.33.33s-.15.33-.33.33h-1.46v1.11h1.46z" />
    ),
  },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '60px 0 0',
    [theme.breakpoints.down('sm')]: { padding: '40px 0 0' },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px',
    [theme.breakpoints.down('md')]: { gridTemplateColumns: '1fr', gap: '18px' },
  },
  card: {
    position: 'relative',
    background: T.color.surface,
    borderRadius: T.radius.xl,
    boxShadow: T.shadow.card,
    padding: '52px 28px 30px',
    textAlign: 'center',
    height: '100%',
  },
  badge: {
    position: 'absolute',
    top: -35,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 70,
    height: 70,
    borderRadius: '50%',
    boxShadow: T.shadow.md,
  },
  cardTitle: {
    fontFamily: T.font.heading,
    fontSize: 20,
    fontWeight: 700,
    color: T.color.ink,
    margin: '0 0 18px',
  },
  block: {
    marginBottom: 18,
    paddingBottom: 18,
    borderBottom: `1px solid ${T.color.line}`,
    '&:last-child': { marginBottom: 0, paddingBottom: 0, border: 'none' },
  },
  blockHeading: {
    fontFamily: T.font.heading,
    fontSize: 15.5,
    fontWeight: 600,
    // brandDeep (not brand) — T.color.brand fails AA contrast at this size
    // on the white card.
    color: T.color.brandDeep,
    margin: '0 0 6px',
    textAlign: 'left',
  },
  blockText: {
    fontFamily: T.font.body,
    fontSize: 14.5,
    lineHeight: 1.7,
    color: T.color.inkSoft,
    margin: 0,
    textAlign: 'left',
  },
  // Mockup: each email item is ONE horizontal row — BLUE label on the LEFT,
  // outlined white email pill right-aligned to the card's content edge,
  // vertically centered (label-left / pill-right, space-between).
  // Measured from new-design-other/contactus/single.png (1920 wide):
  //   pill width 202px, pill height 35px, row pitch 49px (pill centers),
  //   card content width 405px.
  // Scale-independent ratios used below (so this holds at any viewport):
  //   pill width ÷ content width = 202/405 = 0.499  → `width: '50%'`
  //   pill height ÷ pill width   =  35/202 = 0.173
  //   row pitch  ÷ pill height   =  49/35  = 1.4
  // At 1440 the card content box is ~312px → pill ~156px wide, ~27px tall,
  // pitch ~38px → marginBottom 11. Because the pill is a % of the row (which
  // spans the full content box) all four pills are EQUAL width and their
  // right edges align to the card's content edge automatically.
  emailRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    // pitch = row height (27, the pill) + 11 = 38 ≈ 1.4 × 27 target.
    // NOTE: no `&:last-of-type` rule here — socialRow is the last `div`
    // sibling in the card, so `.emailRow:last-of-type` never matches. The
    // extra gap before the divider is set as the divider's own marginTop.
    marginBottom: 11,
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      gap: '4px 10px',
    },
  },
  emailLabel: {
    fontFamily: T.font.body,
    fontSize: 13.5,
    // Mockup label text measured rgb(0,142,255) ≈ #008EFF — i.e. brand blue,
    // NOT the grey this previously used.
    color: T.color.brand,
    margin: 0,
    textAlign: 'left',
  },
  // Outlined WHITE pill (mockup: interior pure #FFFFFF, 2px #008EFF border,
  // near-black #292929 label text at regular weight) — not the filled
  // light-blue/blue-bold-text pill this previously had.
  emailPill: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: '50%',
    flexShrink: 0,
    minHeight: 27,
    fontFamily: T.font.body,
    fontSize: 13.5,
    fontWeight: 400,
    color: '#292929',
    background: T.color.surface,
    border: `2px solid ${T.color.brand}`,
    borderRadius: T.radius.pill,
    // No vertical padding: minHeight (27 = 0.173 × 156 pill width) governs
    // the height so it matches the mockup ratio exactly.
    lineHeight: 1.5,
    padding: '0 10px',
    textDecoration: 'none',
    transition: 'background 0.2s ease, color 0.2s ease',
    // Sensible hover for an outlined pill: fill brand blue, white text.
    '&:hover': {
      background: T.color.brand,
      color: T.color.onBrand,
      textDecoration: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  // Mockup: a 2px brand-blue rule spanning the FULL card content width sits
  // between the last email row and the social icons (measured y1263-1264,
  // rgb(0,142,255), x1246→1638). Gaps: last pill → divider 29px mockup
  // (×0.75 ≈ 22, set via emailRow last-of-type marginBottom) and divider →
  // social icons 46px mockup (×0.75 ≈ 34, set as marginBottom here).
  emailDivider: {
    border: 0,
    borderTop: `2px solid ${T.color.brand}`,
    width: '100%',
    // marginTop 22 = the mockup's 29px last-pill→divider gap × 0.75. It does
    // NOT add to the row's 11px marginBottom: adjacent block margins COLLAPSE
    // to max(22, 11) = 22, which is exactly the target.
    // marginBottom 34 = mockup 46 × 0.75 (divider → social icons).
    margin: '22px 0 34px',
  },
  socialRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: '14px',
  },
  socialBtn: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    '&:hover': { transform: 'translateY(-3px)' },
    '& svg': { width: 20, height: 20, fill: '#FFFFFF' },
  },
}))

const ContactInfoCards = () => {
  const classes = useStyles()
  const { t } = useTranslation('contact-us')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <div className={classes.grid}>
          <Reveal delay={0}>
            <div className={classes.card}>
              <img
                className={classes.badge}
                src="/static/img/contact-us-new/icon-office.png"
                alt=""
                aria-hidden="true"
                width={70}
                height={70}
                loading="lazy"
              />
              <h2 className={classes.cardTitle}>{t('new.cards.office.title')}</h2>
              <div className={classes.block}>
                <p className={classes.blockHeading}>{t('new.cards.office.company')}</p>
                <p className={classes.blockText}>
                  {t('new.cards.office.address-1')}
                  <br />
                  {t('new.cards.office.address-2')}
                  <br />
                  {t('new.cards.office.address-3')}
                  <br />
                  {t('new.cards.office.address-4')}
                </p>
              </div>
              <div className={classes.block}>
                <p className={classes.blockHeading}>{t('new.cards.office.tax-label')}</p>
                <p className={classes.blockText}>{t('new.cards.office.tax-value')}</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className={classes.card}>
              <img
                className={classes.badge}
                src="/static/img/contact-us-new/icon-phone.png"
                alt=""
                aria-hidden="true"
                width={70}
                height={70}
                loading="lazy"
              />
              <h2 className={classes.cardTitle}>{t('new.cards.phone.title')}</h2>
              <div className={classes.block}>
                <p className={classes.blockHeading}>{t('new.cards.phone.cs-heading')}</p>
                <p className={classes.blockText}>
                  {t('new.cards.phone.cs-days')}
                  <br />
                  {t('new.cards.phone.cs-time')}
                  <br />
                  {t('new.cards.phone.cs-tel')}
                </p>
              </div>
              <div className={classes.block}>
                <p className={classes.blockHeading}>{t('new.cards.phone.acc-heading')}</p>
                <p className={classes.blockText}>
                  {t('new.cards.phone.acc-days')}
                  <br />
                  {t('new.cards.phone.acc-time')}
                  <br />
                  {t('new.cards.phone.acc-tel')}
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className={classes.card}>
              <img
                className={classes.badge}
                src="/static/img/contact-us-new/icon-email.png"
                alt=""
                aria-hidden="true"
                width={70}
                height={70}
                loading="lazy"
              />
              <h2 className={classes.cardTitle}>{t('new.cards.email.title')}</h2>
              {emails.map((e) => (
                <div className={classes.emailRow} key={e.address}>
                  <span className={classes.emailLabel}>
                    {t(`new.cards.email.${e.labelKey}`)}
                  </span>
                  <MuiLink
                    href={`mailto:${e.address}`}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.emailPill}
                  >
                    {e.address}
                  </MuiLink>
                </div>
              ))}
              <hr className={classes.emailDivider} />
              <div className={classes.socialRow}>
                {socials.map((s) => (
                  <a
                    key={s.name}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    className={classes.socialBtn}
                    style={{ background: s.bg }}
                    aria-label={t('new.cards.email.social-aria', { name: s.name })}
                  >
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      {s.path}
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </Container>
    </section>
  )
}

export default ContactInfoCards
